// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub-root {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0b0b1e;
  padding: 20px;
  position: relative;
}

.sub-back-btn {
  position: absolute;
  top: 24px;
  left: 24px;
  padding: 9px 16px;
  background: #131328;
  border: 1.5px solid #2a2a44;
  border-radius: 999px;
  color: #9088bc;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sub-back-btn:hover {
  background: #1e1e40;
  border-color: #6c4fc9;
  color: #c8bcf0;
}

@media (max-width: 480px) {
  .sub-back-btn {
    top: 14px;
    left: 14px;
    padding: 7px 12px;
    font-size: 12px;
  }
}

.sub-card {
  background: #131328;
  border: 1.5px solid #2a2a44;
  border-radius: 16px;
  padding: 32px 30px;
  max-width: 380px;
  width: 100%;
  text-align: center;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}

.sub-current-clicks {
  margin: 16px 0 0 0;
  font-size: 13px;
  color: #9088bc;
}

.sub-current-clicks strong {
  color: #c8bcf0;
}

.sub-title {
  margin: 14px 0 4px 0;
  font-size: 20px;
  font-weight: 800;
  color: #e0d4f8;
}

.sub-price {
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  color: #9b78f0;
}

.sub-sub {
  margin: 4px 0 20px 0;
  font-size: 13px;
  color: #6a6490;
}

.sub-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
}

.sub-label {
  font-size: 12px;
  font-weight: 700;
  color: #9088bc;
}

.sub-input {
  padding: 12px 14px;
  background: #0e0e24;
  border: 1.5px solid #2a2a44;
  border-radius: 9px;
  color: #e0d4f8;
  font-size: 14px;
}

.sub-input:focus {
  outline: none;
  border-color: #6c4fc9;
}

.sub-error {
  color: #ff8a8a;
  font-size: 12px;
  margin: 2px 0;
}

.sub-pay-btn {
  margin-top: 8px;
  padding: 13px;
  background: linear-gradient(135deg, #6c4fc9, #9b78f0);
  border: none;
  border-radius: 9px;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.15s ease;
}

.sub-pay-btn:hover {
  box-shadow: 0 0 16px rgba(108, 79, 201, 0.5);
}

.sub-hint {
  margin-top: 20px;
  font-size: 11.5px;
  color: #6a6490;
  line-height: 1.5;
}

.sub-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 10px 0;
}

.sub-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #2a2a44;
  border-top-color: #9b78f0;
  border-radius: 50%;
  animation: sub-spin 0.8s linear infinite;
  margin-bottom: 6px;
}

@keyframes sub-spin {
  to { transform: rotate(360deg); }
}

.sub-check {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(80, 200, 120, 0.15);
  color: #5ed98a;
  font-size: 24px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}

/* ── Two-plan selector ────────────────────────────────────────────────── */
.sub-plans {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 18px 0 10px;
}
.sub-plan {
  position: relative;
  text-align: left;
  padding: 16px 18px;
  border-radius: 16px;
  border: 1.5px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.03);
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: all 0.15s ease;
}
.sub-plan:hover { border-color: rgba(192, 132, 252, 0.6); }
.sub-plan--active {
  border-color: #c084fc;
  background: rgba(192, 132, 252, 0.12);
  box-shadow: 0 0 0 3px rgba(192, 132, 252, 0.15);
}
.sub-plan-badge {
  position: absolute;
  top: -10px;
  right: 14px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #1a1024;
  background: linear-gradient(90deg, #d946a8, #9333ea);
  padding: 3px 10px;
  border-radius: 999px;
}
.sub-plan-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.sub-plan-price {
  font-size: 1.6rem;
  font-weight: 800;
}
.sub-plan-desc {
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.35;
}
`, "",{"version":3,"sources":["webpack://./src/components/Subscribe.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0BAA0B;AAC5B;AACA,kBAAkB,sCAAsC,EAAE;AAC1D;EACE,qBAAqB;EACrB,qCAAqC;EACrC,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,oDAAoD;EACpD,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;AACnB","sourcesContent":[".sub-root {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #0b0b1e;\n  padding: 20px;\n  position: relative;\n}\n\n.sub-back-btn {\n  position: absolute;\n  top: 24px;\n  left: 24px;\n  padding: 9px 16px;\n  background: #131328;\n  border: 1.5px solid #2a2a44;\n  border-radius: 999px;\n  color: #9088bc;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sub-back-btn:hover {\n  background: #1e1e40;\n  border-color: #6c4fc9;\n  color: #c8bcf0;\n}\n\n@media (max-width: 480px) {\n  .sub-back-btn {\n    top: 14px;\n    left: 14px;\n    padding: 7px 12px;\n    font-size: 12px;\n  }\n}\n\n.sub-card {\n  background: #131328;\n  border: 1.5px solid #2a2a44;\n  border-radius: 16px;\n  padding: 32px 30px;\n  max-width: 380px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);\n}\n\n.sub-current-clicks {\n  margin: 16px 0 0 0;\n  font-size: 13px;\n  color: #9088bc;\n}\n\n.sub-current-clicks strong {\n  color: #c8bcf0;\n}\n\n.sub-title {\n  margin: 14px 0 4px 0;\n  font-size: 20px;\n  font-weight: 800;\n  color: #e0d4f8;\n}\n\n.sub-price {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 800;\n  color: #9b78f0;\n}\n\n.sub-sub {\n  margin: 4px 0 20px 0;\n  font-size: 13px;\n  color: #6a6490;\n}\n\n.sub-form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  text-align: left;\n}\n\n.sub-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #9088bc;\n}\n\n.sub-input {\n  padding: 12px 14px;\n  background: #0e0e24;\n  border: 1.5px solid #2a2a44;\n  border-radius: 9px;\n  color: #e0d4f8;\n  font-size: 14px;\n}\n\n.sub-input:focus {\n  outline: none;\n  border-color: #6c4fc9;\n}\n\n.sub-error {\n  color: #ff8a8a;\n  font-size: 12px;\n  margin: 2px 0;\n}\n\n.sub-pay-btn {\n  margin-top: 8px;\n  padding: 13px;\n  background: linear-gradient(135deg, #6c4fc9, #9b78f0);\n  border: none;\n  border-radius: 9px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 800;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.sub-pay-btn:hover {\n  box-shadow: 0 0 16px rgba(108, 79, 201, 0.5);\n}\n\n.sub-hint {\n  margin-top: 20px;\n  font-size: 11.5px;\n  color: #6a6490;\n  line-height: 1.5;\n}\n\n.sub-status {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 0;\n}\n\n.sub-spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid #2a2a44;\n  border-top-color: #9b78f0;\n  border-radius: 50%;\n  animation: sub-spin 0.8s linear infinite;\n  margin-bottom: 6px;\n}\n\n@keyframes sub-spin {\n  to { transform: rotate(360deg); }\n}\n\n.sub-check {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: rgba(80, 200, 120, 0.15);\n  color: #5ed98a;\n  font-size: 24px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 6px;\n}\n\n/* ── Two-plan selector ────────────────────────────────────────────────── */\n.sub-plans {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 18px 0 10px;\n}\n.sub-plan {\n  position: relative;\n  text-align: left;\n  padding: 16px 18px;\n  border-radius: 16px;\n  border: 1.5px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.03);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  transition: all 0.15s ease;\n}\n.sub-plan:hover { border-color: rgba(192, 132, 252, 0.6); }\n.sub-plan--active {\n  border-color: #c084fc;\n  background: rgba(192, 132, 252, 0.12);\n  box-shadow: 0 0 0 3px rgba(192, 132, 252, 0.15);\n}\n.sub-plan-badge {\n  position: absolute;\n  top: -10px;\n  right: 14px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #1a1024;\n  background: linear-gradient(90deg, #d946a8, #9333ea);\n  padding: 3px 10px;\n  border-radius: 999px;\n}\n.sub-plan-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.7);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n.sub-plan-price {\n  font-size: 1.6rem;\n  font-weight: 800;\n}\n.sub-plan-desc {\n  font-size: 0.82rem;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.35;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
